import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export const SolutionSection = () => {
  return <section className="py-12" data-id="element-431">
      <FadeIn data-id="element-432">
        <div className="bg-gradient-to-b from-slate-900 to-slate-950 p-8 sm:p-10 rounded-2xl border border-slate-800 shadow-xl" data-id="element-433">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6 text-center" data-id="element-434">
            El Mecanismo que Cambia Todo:
            <br data-id="element-435" />
            <span className="text-amber-500" data-id="element-436">El Protocolo 3-2-1</span>
          </h2>

          <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-437">
            <p data-id="element-438">
              Después de analizar los patrones más comunes del reflujo nocturno,
              existe un sistema de{' '}
              <strong data-id="element-439">3 reglas cronológicas y 2 ajustes físicos</strong> que,
              combinados, crean una barrera mecánica contra el ácido mientras
              duermes.
            </p>

            <ul className="space-y-3 list-disc list-inside text-slate-200 ml-2" data-id="element-440">
              <li data-id="element-441">No es una dieta.</li>
              <li data-id="element-442">No es un suplemento.</li>
              <li data-id="element-443">No requiere receta médica.</li>
            </ul>

            <p className="text-xl font-bold text-white text-center py-4" data-id="element-444">
              Es ingeniería aplicada a tu anatomía.
            </p>

            <p className="bg-green-950/30 border border-green-900/50 p-6 rounded-xl text-green-100" data-id="element-445">
              <strong data-id="element-446">El resultado:</strong> tu estómago llega vacío a la cama,
              tu esófago queda físicamente por encima del nivel del ácido, y la
              válvula permanece cerrada toda la noche. Sin fuego. Sin
              interrupciones. Sin pastillas.
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
};